import React from "react";



export const MainLogo:React.FC<{color?:string, classname?:string}> = ({color,classname}) => {
    const fillColor = color?color:"#f97316";
    return (
        <svg
        className={classname}
        // width="17.558315mm"
        // height="14.088154mm"
        viewBox="0 0 17.558315 14.088154"
        version="1.1"
        id="svg5"
        xmlSpace="preserve"      
        
        
        xmlns="http://www.w3.org/2000/svg"
        
        >
        <defs id="defs2" />
        <g
        
            
            id="layer1"
            transform="translate(-36.26748,-60.764086)"
        >
            <circle
            className="blinking"
            style={{
                fill: fillColor,
                fillOpacity: 1,
                stroke: "none",
                strokeWidth: 2.07276,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeMiterlimit: 3.3,
                strokeDasharray: "none",
                strokeOpacity: 1,
            }}
            id="path7439-5-8-2-6-5"
            cx="48.4118"
            cy="68.538673"
            r="1.2166839"
            />
            <circle
            className="blinking"
            style={{
                fill: fillColor,
                fillOpacity: 1,
                stroke: "none",
                strokeWidth: 2.07276,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeMiterlimit: 3.3,
                strokeDasharray: "none",
                strokeOpacity: 1,
            }}
            id="path7439-5-8-2-6-5-2"
            cx="42.559319"
            cy="68.552399"
            r="1.2166839"
            />
            <path
            style={{
                fill: "none",
                stroke: fillColor,
                strokeWidth: 1.5,
                strokeLinecap: "round",
                strokeLinejoin: "round",
                strokeDasharray: "none",
                strokeOpacity: 1,
            }}
            d="m 37.058574,65.729967 c 0.375777,-0.594713 15.288528,-0.203057 15.903249,0.519713 0.614725,0.722769 -1.51948,7.852557 -1.51948,7.852557 L 39.017226,73.997418 c 0,0 -2.334415,-7.67273 -1.958652,-8.267444 z"
            id="path9119-1-4-8"
            />
            <path
            style={{
                fill: "none",
                stroke: fillColor,
                strokeWidth: 1.40329,
                strokeLinecap: "round",
                strokeLinejoin: "miter",
                strokeDasharray: "none",
                strokeOpacity: 1,
            }}
            d="m 45.352939,63.616389 0.62937,-1.725448 1.933451,-0.425212"
            id="path13966-6-6"
            />
        </g>
        </svg>
    );
    };